import { useQuery } from '@apollo/react-hooks'

import { LinkedAccount, LinkedSubaccount, RoundUpAccount, RoundUpProfile } from 'generated/types'

import linkedAccountsAndFundingSourceQuery from './gql/query.LinkedAccounts.gql'

type LinkedAccountAndRoundUpProfile = LinkedAccount & RoundUpProfile

const useFormRows = () => {
  const { data, error, loading } = useQuery<LinkedAccountAndRoundUpProfile>(
    linkedAccountsAndFundingSourceQuery,
    {
      fetchPolicy: 'network-only',
    },
  )

  const linkedAccounts: LinkedSubaccount[] = data?.linkedAccounts[0]?.linkedSubaccounts
  const roundUpAccounts: RoundUpAccount[] = data?.roundUpProfile?.roundUpAccounts
  return {
    formRowData: {
      linkedAccounts,
      roundUpAccounts,
    },
    error,
    loading,
  }
}

export { useFormRows }
